function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwListbox from 'viewmodel/AwListboxViewModel';
import AwPopupWrapper from 'viewmodel/AwPopupWrapperViewModel';
import AccSearchBox from 'viewmodel/AccSearchBoxViewModel';
import { ExistWhen, VisibleWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
const DivVisibleWhen = VisibleWhen('div');
DivExistWhen.displayName = 'DivExistWhen';
DivVisibleWhen.displayName = 'DivVisibleWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('viewmodel/SearchHistoryViewModel', () => import('viewmodel/SearchHistoryViewModel'));
registerDynImportEntry('js/accSearchBoxService', () => import('js/accSearchBoxService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": ["js/lovService"],
  "ports": {},
  "actions": {
    "searchBoxOnInitBatchActions": {
      "actionType": "batchJob",
      "steps": [{
        "action": "registerSearchEvents"
      }, {
        "action": "validateCategoryExtensionSrc"
      }, {
        "action": "removeCategoryIfAny"
      }, {
        "action": "onMountCategoryFunction"
      }]
    },
    "registerSearchEvents": {
      "actionType": "JSFunction",
      "method": "addAccEvents",
      "inputData": {
        "eventIds": ["des-search.query", "des-search-filter.apply", "des-search-filter.clear"]
      },
      "deps": "js/desSearchService"
    },
    "doSearch": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "des.search.input.changed",
          "eventData": {
            "query": "{{data.searchBox.dbValue}}",
            "category": "{{data.category.dbValue}}",
            "categoryUi": "{{data.category.uiValue}}",
            "ownership": "{{data.ownership}}",
            "searchFilters": "{{data.searchFilters}}"
          }
        }]
      },
      "events": {
        "success": [{
          "name": "searchChanged",
          "eventData": {
            "searchInput": {
              "query": "{{data.searchBox.dbValue}}",
              "category": "{{data.category.dbValue}}",
              "categoryUi": "{{data.category.uiValue}}",
              "ownership": "{{data.ownership}}",
              "facets": "{{data.searchFilters}}"
            }
          }
        }, {
          "name": "updateHistory",
          "eventData": {
            "query": "{{data.searchBox.dbValue}}",
            "category": "{{data.category.dbValue}}",
            "categoryUi": "{{data.category.uiValue}}",
            "searchFilters": "{{data.searchFilters}}"
          }
        }, {
          "name": "updateData",
          "eventData": {
            "query": "{{data.searchBox.dbValue}}",
            "category": "{{data.category.dbValue}}",
            "categoryUi": "{{data.category.uiValue}}",
            "searchFilters": "{{data.searchFilters}}"
          }
        }]
      }
    },
    "processQueryEvent": {
      "actionType": "batchJob",
      "steps": [{
        "action": "updateData"
      }, {
        "action": "doSearch"
      }]
    },
    "processFilterEvent": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "searchFilters": "{{data.eventData.facets}}"
        }
      },
      "deps": "js/desSearchService",
      "events": {
        "success": [{
          "name": "des-search.query",
          "eventData": {
            "query": "{{data.searchBox.dbValue}}",
            "category": "{{data.category.dbValue}}",
            "categoryUi": "{{data.category.uiValue}}",
            "searchFilters": "{{data.eventData.facets}}"
          }
        }]
      }
    },
    "updateHistory": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation SetSearchHistory($searchHistory: Json) { setSearchHistory(searchHistory: $searchHistory) }",
            "variables": {
              "searchHistory": {
                "query": "{{data.eventData.query}}",
                "category": "{{data.eventData.category}}",
                "categoryUi": "{{data.eventData.categoryUi}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "deps": "js/desSearchService"
    },
    "updateData": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "searchBox.dbValue": "{{data.eventData.query}}",
          "searchBox.uiValue": "{{data.eventData.query}}",
          "category.dbValue": "{{data.eventData.category}}",
          "category.uiValue": "{{data.eventData.categoryUi}}",
          "searchFilters": "{{data.eventData.facets}}"
        }
      },
      "deps": "js/desSearchService"
    },
    "processClearEvent": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "searchFilters": []
        }
      },
      "deps": "js/desSearchService",
      "events": {
        "success": [{
          "name": "des-search.query",
          "eventData": {
            "query": "{{data.searchBox.dbValue}}",
            "category": "{{data.category.dbValue}}",
            "categoryUi": "{{data.category.uiValue}}",
            "searchFilters": []
          }
        }]
      }
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "addSessionToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "search.accsessionid",
        "value": "{{props.accsessionid}}"
      }
    },
    "showHistory": {
      "actionType": "popup",
      "inputData": {
        "options": {
          "view": "SearchHistory",
          "placement": "bottom-start",
          "width": 300,
          "height": 240,
          "hasArrow": false,
          "toggleMode": true,
          "whenParentScrolls": "close",
          "clickOutsideToClose": true
        }
      }
    },
    "closeHistory": {
      "actionType": "JSFunction",
      "method": "closePopup",
      "inputData": {
        "data": "{{data}}"
      },
      "deps": "js/desSearchService"
    },
    "removeCategoryIfAny": {
      "actionType": "JSFunction",
      "method": "removeCategoryIfAny",
      "inputData": {
        "data": "{{data}}",
        "removeCategory": "{{props.removecategory}}"
      },
      "deps": "js/desSearchService"
    },
    "setCategory": {
      "actionType": "JSFunction",
      "method": "setCategory",
      "inputData": {
        "data": "{{data}}",
        "categoryInput": "{{ctx.categoryInputValidData.categories}}"
      },
      "deps": "js/desSearchService"
    },
    "invalidCategoryNotification": {
      "actionType": "JSFunction",
      "method": "invalidCategoryNotification",
      "inputData": {
        "errorData": "{{ctx.categoryInputErrors}}",
        "categoryInput": "{{ctx.categoryInput}}",
        "vmo": "{{data}}"
      },
      "outputData": {
        "invalidCategoryInputError": "invalidCategoryInputError"
      },
      "actionMessages": {
        "success": [{
          "message": "invalidCategoryInputErrorMsg"
        }]
      },
      "deps": "js/desSearchService"
    },
    "setOwnershipFilterValue": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "ownership": "{{data.eventData.value}}"
        }
      },
      "events": {
        "success": [{
          "name": "updateOwnershipVmo.success"
        }]
      },
      "deps": "js/desSearchService"
    },
    "checkSearchInput": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "searchInputPresent",
          "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length > 0"
        }]
      }
    },
    "validateCategoryExtensionSrc": {
      "actionType": "JSFunction",
      "method": "validateCategoryExtensionSrc",
      "inputData": {
        "extensionssrc": "{{props.extensionSrc}}"
      },
      "deps": "js/desSearchService"
    },
    "onMountCategoryFunction": {
      "actionType": "JSFunction",
      "method": "onMountCategoryFunction",
      "deps": "js/desSearchService"
    },
    "performBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addSessionToCtx"
      }, {
        "action": "checkSearchInput"
      }, {
        "action": "searchBoxOnFocusHandler"
      }]
    },
    "searchBoxOnFocusHandler": {
      "actionType": "JSFunction",
      "method": "onFocusHandler",
      "inputData": {
        "searchInput": "{{data.searchBox.dbValue}}"
      },
      "deps": "js/accSearchBoxService"
    }
  },
  "data": {
    "searchBox": {
      "displayName": "{{i18n.search}}",
      "type": "STRING",
      "dbValue": "{{props.searchInput}}",
      "dispValue": "{{props.searchInput}}"
    },
    "category": {
      "displayName": "Category",
      "name": "category",
      "type": "STRING",
      "isRequired": false,
      "hasLov": true,
      "dbValue": "allCategories",
      "dispValue": "{{i18n.allCategories}}"
    },
    "categoryValues": {
      "type": "STRING",
      "dbValue": [{
        "propDisplayValue": "{{i18n.allCategories}}",
        "dispValue": "{{i18n.allCategories}}",
        "propInternalValue": "allCategories",
        "removeCategoryName": "All Categories"
      }, {
        "propDisplayValue": "{{i18n.designs}}",
        "dispValue": "{{i18n.designs}}",
        "propInternalValue": "mechanicalcaddomain",
        "removeCategoryName": "Designs"
      }, {
        "propDisplayValue": "{{i18n.documents}}",
        "dispValue": "{{i18n.documents}}",
        "propInternalValue": "documentmanagement",
        "removeCategoryName": "Documents"
      }, {
        "propDisplayValue": "{{i18n.electricalAndElectronics}}",
        "dispValue": "{{i18n.electricalAndElectronics}}",
        "propInternalValue": "ecadcapital",
        "removeCategoryName": "Electrical and Electronics"
      }, {
        "propDisplayValue": "{{i18n.folders}}",
        "dispValue": "{{i18n.folders}}",
        "propInternalValue": "folders",
        "removeCategoryName": "Folders"
      }, {
        "propDisplayValue": "{{i18n.mechanicalEngineering}}",
        "dispValue": "{{i18n.mechanicalEngineering}}",
        "propInternalValue": "Mechanical Engineering",
        "removeCategoryName": "Mechanical Engineering"
      }, {
        "propDisplayValue": "{{i18n.manufacturing}}",
        "dispValue": "{{i18n.manufacturing}}",
        "propInternalValue": "plantsimulation",
        "removeCategoryName": "Manufacturing"
      }, {
        "propDisplayValue": "{{i18n.3DVisualizationAndCollaboration}}",
        "dispValue": "{{i18n.3DVisualizationAndCollaboration}}",
        "propInternalValue": "3D Visualization and Collaboration",
        "removeCategoryName": "3D Visualization and Collaboration"
      }, {
        "propDisplayValue": "{{i18n.simulationAndTest}}",
        "dispValue": "{{i18n.simulationAndTest}}",
        "propInternalValue": "simulation",
        "removeCategoryName": "Simulation and Test"
      }]
    },
    "ownership": "anyOne"
  },
  "i18n": {
    "3DVisualizationAndCollaboration": ["projectMessages"],
    "allCategories": ["projectMessages"],
    "designs": ["projectMessages"],
    "documents": ["projectMessages"],
    "electricalAndElectronics": ["projectMessages"],
    "folders": ["projectMessages"],
    "manufacturing": ["projectMessages"],
    "mechanicalEngineering": ["projectMessages"],
    "simulationAndTest": ["projectMessages"],
    "search": ["projectMessages"],
    "categoryInputErrorMsg1": ["projectMessages"],
    "categoryInputErrorMsg2": ["projectMessages"],
    "categoryInputErrorMsg3": ["projectMessages"],
    "categoryInputErrorMsg4": ["projectMessages"],
    "categoryInputErrorMsg5": ["projectMessages"]
  },
  "lifecycleHooks": {
    "onInit": "searchBoxOnInitBatchActions",
    "onMount": "performBatchAction"
  },
  "onEvent": [{
    "eventId": "searchChanged",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-search-box.change",
      "eventData": "{{eventData.searchInput}}"
    }
  }, {
    "eventId": "updateData",
    "action": "updateData",
    "cacheEventData": true
  }, {
    "eventId": "updateHistory",
    "action": "updateHistory",
    "cacheEventData": true
  }, {
    "eventId": "des-search.query",
    "action": "processQueryEvent",
    "cacheEventData": true
  }, {
    "eventId": "updateData",
    "action": "closeHistory"
  }, {
    "eventId": "des-search-filter.apply",
    "action": "processFilterEvent",
    "cacheEventData": true
  }, {
    "eventId": "des-search-filter.clear",
    "action": "processClearEvent"
  }, {
    "eventId": "des.ownership.input.changed",
    "action": "setOwnershipFilterValue",
    "cacheEventData": true
  }, {
    "eventId": "updateOwnershipVmo.success",
    "action": "doSearch"
  }, {
    "eventId": "searchInputPresent",
    "action": "doSearch"
  }, {
    "eventId": "des-search-category.valid",
    "action": "setCategory"
  }, {
    "eventId": "des-search-category.invalid",
    "action": "invalidCategoryNotification"
  }],
  "messages": {
    "invalidCategoryInputErrorMsg": {
      "messageType": "ERROR",
      "messageText": "{{data.invalidCategoryInputError}}"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "hide-category": {
      "type": "boolean"
    },
    "removecategory": {
      "type": "string"
    },
    "search-input": {
      "type": "string"
    },
    "showOwnershipFilter": {
      "type": "string"
    },
    "extensionSrc": {
      "type": "string"
    }
  },
  "conditions": {
    "enableOwnershipFilter": {
      "expression": "( props.showOwnershipFilter === true || props.showOwnershipFilter === 'true' )"
    }
  },
  "_viewModelId": "SearchBox",
  "_uniqueViewModelId": "SearchBox",
  "ctx": {
    "categoryInputValidData": {
      "type": "object"
    },
    "categoryInputErrors": {
      "type": "object"
    },
    "categoryInput": {
      "type": "object"
    }
  }
};

/*
<div class="des-search-box-view-container">
    <div class="des-search-box-view-category" exist-when='conditions.enableOwnershipFilter'>
        <des-ownership-lov acc-session-id="{{props.accsessionid}}">
        </des-ownership-lov>
    </div>
    <div id="search-box-category-list" class="des-search-box-view-category" visible-when='!props.hideCategory'>
        <aw-listbox prop="data.category" list="data.categoryValues.dbValue" labeldisplay="headless" action="doSearch">
        </aw-listbox>
    </div>
    <div class="des-search-box-view-box">
        <aw-popup-wrapper popup="showHistory">
            <acc-search-box prop="data.searchBox" placeholder="data.searchBox.propertyDisplayName"
                action="doSearch" click-action="showHistory" ix-enabled="{{props.ixEnabled}}"></acc-search-box>
        </aw-popup-wrapper>
    </div>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "des-search-box-view-container"
  }, /*#__PURE__*/React.createElement(DivExistWhen, {
    className: "des-search-box-view-category",
    existWhen: AwParseService.instance("conditions.enableOwnershipFilter")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("des-ownership-lov", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    id: "search-box-category-list",
    className: "des-search-box-view-category",
    visibleWhen: AwParseService.instance("!props.hideCategory")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwListbox, _extends({}, getField("data.category", fields, $index, null, null), {
    list: AwParseService.instance("data.categoryValues.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    labeldisplay: "headless",
    action: actions.doSearch
  }))), /*#__PURE__*/React.createElement("div", {
    className: "des-search-box-view-box"
  }, /*#__PURE__*/React.createElement(AwPopupWrapper, {
    popup: actions.showHistory
  }, /*#__PURE__*/React.createElement(AccSearchBox, _extends({}, getField("data.searchBox", fields, $index, null, null), {
    placeholder: AwParseService.instance("data.searchBox.propertyDisplayName")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    action: actions.doSearch,
    clickAction: actions.showHistory,
    ixEnabled: AwParseService.instance("props.ixEnabled")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;